<div *ngIf="visible" class="slot" [class.slot--disabled]="disabled" [class.slot--full]="atCapacity">
  <div class="slot__col slot__col--label">
    <span class="slot__label">
      {{ label }}
      <span *ngIf="required" class="slot__required" title="Obligatorio">*</span>
    </span>
    <span class="slot__count" *ngIf="files?.length">{{ files.length }}/{{ maxFiles }}</span>
  </div>

  <div class="slot__col slot__col--drop">
    <div
      class="slot__drop"
      appDragDrog
      (fileDropped)="onDrop($event)"
      [class.slot__drop--disabled]="disabled || atCapacity"
    >
      <input
        #fileInput
        type="file"
        class="slot__input"
        [id]="inputId"
        [accept]="accept"
        [disabled]="disabled || atCapacity"
        multiple
        (change)="onBrowse(fileInput)"
      />
      <label [for]="inputId" class="slot__cta">
        <svg class="slot__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="17 8 12 3 7 8"></polyline>
          <line x1="12" y1="3" x2="12" y2="15"></line>
        </svg>
        <span class="slot__cta-text">
          <ng-container *ngIf="!atCapacity">Arrastra o <u>busca</u></ng-container>
          <ng-container *ngIf="atCapacity">Máximo alcanzado</ng-container>
        </span>
      </label>
    </div>
  </div>

  <div class="slot__col slot__col--files">
    <ul class="slot__files" *ngIf="files?.length; else noFiles">
      <li class="slot__chip" *ngFor="let file of files; let i = index">
        <svg class="slot__chip-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
        </svg>
        <span class="slot__chip-name" [title]="file?.name">{{ file?.name }}</span>
        <span class="slot__chip-size">{{ formatBytes(file?.size) }}</span>
        <button
          type="button"
          class="slot__chip-remove"
          [disabled]="disabled || uploading"
          (click)="onRemove(i)"
          aria-label="Eliminar archivo"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </li>
    </ul>
    <ng-template #noFiles>
      <span class="slot__empty">—</span>
    </ng-template>
  </div>

  <div class="slot__progress" *ngIf="uploading && files?.length">
    <div class="slot__progress-bar" [style.width.%]="progress"></div>
  </div>
</div>
